<template>
  <div class="BProfileCard">
    <v-list-item
      :two-line="twoLine"
      :class="mini && 'px-2'"
    >
      <v-list-item-avatar v-if="link">
        <v-btn
          icon
          color="primary"
          :to="link"
          :disabled="link.name === $route.name"
        >
          <v-img
            v-if="profile.photo"
            :src="profile.photo"
          />
          <v-icon v-else>
            mdi-account
          </v-icon>
        </v-btn>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title :style="twoLine && 'white-space: normal;'">
          <span>{{ profile.full_name }}</span>
        </v-list-item-title>
        <v-list-item-subtitle>{{ profile.username }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>


export default {
  name: 'BProfileCard',
  props: {
    twoLine: Boolean,
    link: Object,
    profile: {
      type: Object,
      required: true,
    },
    mini: {
      type: Boolean,
      reqired: true,
    },
  },
}
</script>
